import { IMAGES } from "@/lib/site";

const PAIRS = [
  {
    image: IMAGES.beforeAfter1,
    project: "Full Roof Replacement",
    detail: "Curling three-tab strip replaced with charcoal architectural shingles. Full ice & water shield, metal valleys, new ridge ventilation.",
  },
  {
    image: IMAGES.beforeAfter2,
    project: "Full Roof Replacement",
    detail: "Weathered shingles retired for a dimensional asphalt system. Updated flashing at the chimney and valleys, pipe boots replaced.",
  },
];

export default function BeforeAfter() {
  return (
    <section
      id="work"
      data-testid="beforeafter-section"
      className="theme-light relative bg-[#F4F5F6] py-24 lg:py-24"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-16 lg:mb-12">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#D4A84B]" />
              <span className="es-label text-[#D4A84B]">Before & After</span>
            </div>
            <h2 className="font-serif-display text-[#101010] text-4xl sm:text-5xl leading-[1.05] tracking-tight">
              Recent work,
              <br />
              side by side.
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 flex items-end">
            <p className="text-[#4B5055] text-base sm:text-lg leading-relaxed">
              Real Wisconsin homes. Real Everstone crews. No staging — just before
              and after, exactly as the job came together.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-12">
          {PAIRS.map((p, i) => (
            <article
              key={i}
              data-testid={`beforeafter-pair-${i}`}
              className="group"
            >
              <div className="relative overflow-hidden border border-[#E5E7EB] bg-white">
                <img
                  src={p.image}
                  alt={`Before and after — ${p.project}, ${p.location}`}
                  className="w-full h-auto object-cover transition-transform duration-[1400ms] group-hover:scale-[1.03]"
                  loading="lazy"
                />
                <div className="pointer-events-none absolute top-4 left-4 px-3 py-1.5 bg-[#101010]/85 backdrop-blur-sm border border-[#D4A84B]/40">
                  <span className="es-label text-[#D4A84B]">Before / After</span>
                </div>
              </div>

              <div className="mt-6">
                <h3 className="font-serif-display text-[#101010] text-xl sm:text-2xl leading-tight">
                  {p.project}
                </h3>
                <p className="text-[#4B5055] text-sm mt-3 leading-relaxed max-w-xl">
                  {p.detail}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
